import { render, staticRenderFns } from "./chairman.vue?vue&type=template&id=7336dca2&scoped=true&"
import script from "./chairman.vue?vue&type=script&lang=js&"
export * from "./chairman.vue?vue&type=script&lang=js&"
import style0 from "./chairman.vue?vue&type=style&index=0&id=7336dca2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7336dca2",
  null
  
)

export default component.exports